import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/main.vue'),
    meta: { keepAlive: false }
  },{
    path: '/video-play',
    name: 'video-play',
    component: () => import('../views/video-play.vue'),
  },{
    path: '/main2',
    name: 'main2',
    component: () => import('../views/main2.vue'),
  },{
    path: '/main3',
    name: 'main3',
    component: () => import('../views/main3.vue'),
  },{
    path: '/main4',
    name: 'main4',
    component: () => import('../views/main4.vue'),
  },{
    path: '/register',
    name: 'register',
    component: () => import('../views/register.vue'),
  },{
    path: '/login_pwd',
    name: 'login_pwd',
    component: () => import('../views/login_pwd.vue'),
  },{
    path: '/yyxy',
    name: 'yyxy',
    component: () => import('../views/yyxy.vue'),
  },{
    path: '/banner_xq',
    name: 'banner_xq',
    component: () => import('../views/banner_xq.vue'),
  },{
    path: '/shooping_mall',
    name: 'shooping_mall',
    component: () => import('../views/shooping_mall.vue'),
  },{
    path: '/goods_detail',
    name: 'goods_detail',
    component: () => import('../views/goods_detail.vue'),
  },{
    path: '/confim_order',
    name: 'confim_order',
    component: () => import('../views/confim_order.vue'),
  },{
    path: '/notice',
    name: 'notice',
    component: () => import('../views/notice.vue'),
  },{
    path: '/notice_detail',
    name: 'notice_detail',
    component: () => import('../views/notice_detail.vue'),
  },{
    path: '/first_mall',
    name: 'first_mall',
    component: () => import('../views/first_mall.vue'),
  },{
    path: '/first_mall_visitor',
    name: 'first_mall_visitor',
    component: () => import('../views/first_mall_visitor.vue'),
  },{
    path: '/tj',
    name: 'tj',
    component: () => import('../views/tj.vue'),
  },{
    path: '/more_zx',
    name: 'more_zx',
    component: () => import('../views/more_zx.vue'),
  },{
    path: '/zx_xq',
    name: 'zx_xq',
    component: () => import('../views/zx_xq.vue'),
  },{
    path: '/detail',
    name: 'detail',
    component: () => import('../views/detail.vue'),
  },{
    path: '/fa',
    name: 'fa',
    component: () => import('../views/fa.vue'),
  },{
    path: '/qrcode',
    name: 'qrcode',
    component: () => import('../views/qrcode.vue'),
  },{
    path: '/my_information',
    name: 'my_information',
    component: () => import('../views/my_information.vue'),
  },{
    path: '/set',
    name: 'set',
    component: () => import('../views/set.vue'),
  },{
    path: '/about_us',
    name: 'about_us',
    component: () => import('../views/about_us.vue'),
  },{
    path: '/xiu_pwd',
    name: 'xiu_pwd',
    component: () => import('../views/xiu_pwd.vue'),
  },{
    path: '/tixian_all',
    name: 'tixian_all',
    component: () => import('../views/tixian_all.vue'),
  },{
    path: '/tixain_record',
    name: 'tixain_record',
    component: () => import('../views/tixain_record.vue'),
  },{
    path: '/tixian',
    name: 'tixian',
    component: () => import('../views/tixian.vue'),
  },{
    path: '/my_address',
    name: 'my_address',
    component: () => import('../views/my_address.vue'),
  },{
    path: '/add_address',
    name: 'add_address',
    component: () => import('../views/add_address.vue'),
  },{
    path: '/apply_send',
    name: 'apply_send',
    component: () => import('../views/apply_send.vue'),
  },{
    path: '/my_lower',
    name: 'my_lower',
    component: () => import('../views/my_lower.vue'),
  },{
    path: '/data',
    name: 'data',
    component: () => import('../views/data.vue'),
  },{
    path: '/shou_record',
    name: 'shou_record',
    component: () => import('../views/shou_record.vue'),
  },{
    path: '/my_order',
    name: 'my_order',
    component: () => import('../views/my_order.vue'),
  },{
    path: '/sendOrder',
    name: 'sendOrder',
    component: () => import('../views/sendOrder.vue'),
  },{
    path: '/wxOrderLogin',
    name: 'wxOrderLogin',
    component: () => import('../views/wxOrderLogin.vue'),
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// 添加路由守卫，验证登录状态
router.beforeEach((to, from, next) => {
  //  if (to.meta.title) {
  //   document.title = to.meta.title  // 核心代码
  // }
  next()
})

router.onError((err) => {
  if (err.name === 'NavigationCancelledError' || err.name === 'NavigationDuplicatedError') {
    return
  }
  console.error('路由错误:', err)
})

export default router
